import { Firmware } from 'models/install-verification-tags/tag/firmware/Firmware';
import {
  StatusType,
  StatusTypeDescriptor,
  StatusTypeToken,
} from 'models/install-verification-tags/types';
import type {
  IInstallVerificationTagData,
  ITag,
  ITagStatus,
  TagType,
} from 'models/install-verification-tags/types';

export class SlapAndTrackFirmware extends Firmware {
  constructor(tagType: TagType, tagData: IInstallVerificationTagData) {
    super(tagType, tagData);
  }

  getStatus(): ITagStatus {
    /**
     * Currently there is no way to determine if the firmware
     * is up to date so we will just return a success status
     * as long as the firmware version is not empty.
     */
    this.statusType = StatusType.SUCCESS;
    this.statusDetail = `Device Firmware is ${this.firmware}`;
    if (!this.isValidFirmwareData()) {
      this.statusType = StatusType.UNKNOWN;
      this.statusDetail = `Device Firmware is ${this.firmware}`;
    }
    return {
      status: this.statusType,
      statusToken: StatusTypeToken[this.statusType],
      statusDescriptor: StatusTypeDescriptor[this.statusType],
    };
  }

  createTag(): ITag {
    if (!this.isValidFirmwareData()) {
      return this.createDefaultTag();
    }
    const statusMeta = this.getStatus();
    return {
      ...this.defaults,
      status: statusMeta.status,
      statusToken: statusMeta.statusToken,
      tagText: SlapAndTrackFirmware.getTagTextTemplate(this.tagType, statusMeta.statusDescriptor),
      description: `${this.statusDetail}`,
    };
  }
}
